namespace Solovis.Reports.Parts.Tables.DataTableHelpers {
    export class ColumnColumnDialog {
        public _tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _customId: string;
        public _customColumn: any;
        public _dialog: Solovis.UI.Dialog;
        public _formBuilder: Solovis.UI.InputControls.FormBuilder;

        constructor(options) {
            var self = this;
            this._tableControl = options.tableControl;
            this._customId = options.customId ? options.customId : null;

            var customColumnSettings =
                this._tableControl.columnSet.getSerializableCustomColumnSettings();
            var currentCustomColumn = _.find(customColumnSettings, function (i: any) {
                return i.customId === self._customId;
            });

            this._customColumn = Solovis.deepCopy(currentCustomColumn);
        }

        public show() {
            var self = this;

            if (this._dialog) {
                return;
            }

            var formBuilderDiv = $('<div>');

            var formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
            });
            this._formBuilder = formBuilder;

            // Name
            formBuilder.addEntry({
                name: 'customId',
                label: 'Custom Id',

                help: "Custom id is the id suffix for the column. The generated column id will be 'custom_customId'.",

                initialValue: this._customColumn ? this._customColumn.customId : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: 'text',
                        required: true,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        fireValueChangedOnKeyup: true,
                    });

                    return editorControl;
                },
            });

            // Label
            formBuilder.addEntry({
                name: 'label',
                label: 'Label',

                help: 'Label is the default human-readable label for the column.',

                initialValue: this._customColumn ? this._customColumn.label : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: 'text',
                        required: true,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        fireValueChangedOnKeyup: true,
                    });

                    return editorControl;
                },
            });

            // Data Type
            formBuilder.addEntry({
                name: 'dataType',
                label: 'Data Type',

                initialValue: this._customColumn ? this._customColumn.dataType : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: 'select',
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        fireValueChangedOnKeyup: true,
                        data: [
                            { text: '', value: '' },
                            { text: 'bool', value: 'bool' },
                            { text: 'currency', value: 'currency' },
                            { text: 'dayId', value: 'dayId' },
                            { text: 'integer', value: 'integer' },
                            { text: 'number', value: 'number' },
                            { text: 'percentage', value: 'percentage' },
                            { text: 'string', value: 'string' },
                            { text: 'visualization', value: 'visualization' },
                        ],
                    });

                    return editorControl;
                },
            });

            // Formula
            formBuilder.addEntry({
                name: 'formula',
                label: 'Formula',

                help: { url: '~/Help/CustomJavascriptReportHelp/ParameterTransforms' },

                initialValue: this._customColumn ? this._customColumn.formula : null,

                createEditor: function (createEditorOptions) {
                    var editorContainer = createEditorOptions.container;

                    // editorControlDiv determines size of text area inside (which will scale to 100% of available area)
                    var editorControlDiv = $('<div>').appendTo(editorContainer);
                    editorControlDiv.css({
                        height: '220px',
                        'padding-bottom': '10px',
                    });

                    var editorControl = new Solovis.UI.InputControls.TextAreaInputControl(
                        {
                            container: editorControlDiv,
                            value: createEditorOptions.initialValue,
                            validationModel: createEditorOptions.validationModel,
                            fireValueChangedOnKeyup: true,
                            width: '100%',
                            height: '100%',
                        }
                    );

                    $(editorControlDiv).dxResizable({
                        handles: 'bottom',
                    });

                    var extraDiv = $('<div>')
                        .appendTo(editorContainer)
                        .css('margin-top', '10px');

                    // Allow user to insert script for a column reference.
                    var insertScriptSnippet = function (snippet) {
                        var textbox = $('textarea', editorControlDiv);
                        var caretPos = (textbox[0] as HTMLTextAreaElement).selectionStart;
                        var txtAreaText = textbox.val();
                        textbox.val(
                            txtAreaText.substring(0, caretPos) +
                            snippet +
                            txtAreaText.substring(caretPos)
                        );
                    };

                    var colList = self._tableControl.columnSet.getColumnList();

                    var insertColumnRefLink = $('<a>')
                        .text('Insert Column Reference')
                        .appendTo(extraDiv);
                    Solovis.UI.PopupLinkPanel.onElementClick(
                        insertColumnRefLink,
                        function (e) {
                            var insertLinks = [];

                            $(colList).each(function (i, col: any) {
                                var compositeLabel = col.getCompositeLabel();
                                // The first parameter to column is the id of the column. The second parameter is ignored, but the
                                // composite label is supplied for documentary purposes as the description.
                                var snippet = 'column(' + JSON.stringify(col.id) + ')';

                                insertLinks.push({
                                    label: compositeLabel,
                                    click: function () {
                                        insertScriptSnippet(snippet);
                                    },
                                });
                            });

                            Solovis.UI.PopupLinkPanel.showLinks({
                                links: insertLinks,
                                offset: { left: e.pageX, top: e.pageY },
                                useLegacyPanel: true,
                            });
                        }
                    );

                    return editorControl;
                },
            });

            var desiredWidth = Math.min($(window).width() * 0.9, 800);
            var desiredHeight = Math.min($(window).height() * 0.9, 500);

            this._dialog = formBuilder.showAsDialog({
                saveButtonText: 'OK',
                showSaveCancel: true,
                saveCallback: () => {
                    if (self._saveCustomColumn()) {
                        return true;
                    } else {
                        return false;
                    }
                },

                desiredWidth: desiredWidth,
                desiredHeight: desiredHeight,

                title: 'Custom Column',
                modal: true,
            });
        }

        public _saveCustomColumn() {
            if (this._formBuilder.hasErrors()) {
                return false;
            }

            // TODO: we should type all of this
            var customColumn = this._customColumn;
            if (!customColumn) {
                customColumn = {};
            }

            customColumn.customId = this._formBuilder.getValueByName('customId');
            customColumn.label = this._formBuilder.getValueByName('label');
            customColumn.dataType = this._formBuilder.getValueByName('dataType');
            customColumn.formula = this._formBuilder
                .getValueByName('formula')
                .toString()
                .trim();

            if (this._customId !== customColumn.customId) {
                if (
                    this._tableControl.columnSet.hasCustomColumnWithCustomId(
                        customColumn.customId
                    )
                ) {
                    // TODO: Do this within FormBuilder entry custom validation.
                    Solovis.UI.alert(
                        'Custom Id is already in use by another custom column.'
                    );
                    return false;
                }
            }

            this._tableControl.columnSet.updateCustomColumnSettings(customColumn);

            $(this).trigger('customColumnUpdated', {
                customId: customColumn.customId,
            });

            return true;
        }
    }
}
